export default __webpack_public_path__ + "static/media/vega_logo.cbf28545.png";